import {
  addBank,
  createRechargeLine,
  getauditList,
  changeBankCardInform,
  getBankList,
  getQRCode,
  getRechargeChannels,
  getRechargeMoney,
  getRechargeRecord,
  getRechargeSetting,
  getremitList,
  updateBank,
  updateRechargeLine,
  updateRechargeMoney,
  updateRechargeSetting,
  surePayedFor,
  notPayedFor,
  changeRemitCardInfotm
} from "@/api/modules/rechargeManagement";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getRechargeSettingAction = createAsyncThunk(
  "rechargeManagement/getRechargeSetting",
  async () => {
    // getUserChannels函数是一个axios的请求
    const result = await getRechargeSetting();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getBankListAction = createAsyncThunk(
  "rechargeManagement/getBankList",
  async (params:any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getBankList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getRechargeChannelsAction = createAsyncThunk(
  "rechargeManagement/getRechargeChannels",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getRechargeChannels(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const updateRechargeSettingAction = createAsyncThunk(
  "rechargeManagement/updateRechargeSetting",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateRechargeSetting(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const createRechargeLineAction = createAsyncThunk(
  "rechargeManagement/createRechargeLine",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await createRechargeLine(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getQRCodeAction = createAsyncThunk(
  "rechargeManagement/getQRCode",
  async (filename: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getQRCode(filename);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const updateRechargeLineAction = createAsyncThunk(
  "rechargeManagement/updateRechargeLine",
  async ({ channelId, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateRechargeLine(channelId, data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const addBankAction = createAsyncThunk(
  "rechargeManagement/addBank",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await addBank(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const updateBankAction = createAsyncThunk(
  "rechargeManagement/updateBank",
  async ({ bankId, data }: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateBank(bankId, data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getRechargeMoneyAction = createAsyncThunk(
  "rechargeManagement/getRechargeMoney",
  async () => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getRechargeMoney();

    if (!result.error) return result.data.amountList;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const updateRechargeMoneyAction = createAsyncThunk(
  "rechargeManagement/updateRechargeMoney",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await updateRechargeMoney(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getRechargeRecordAction = createAsyncThunk(
  "rechargeManagement/getRechargeRecord",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getRechargeRecord(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);


export const getauditListAction = createAsyncThunk(
  "rechargeManagement/getauditList",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getauditList(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);
// 提现客服审核银行卡提现申请
export const getBankCardInform = createAsyncThunk(
  "rechargeManagement/changeBankCardInform",
  async (data:any) => {
    const result: any = await changeBankCardInform(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
})
// 财务客服银行卡提现打款
export const getRemitCardInform = createAsyncThunk(
  "rechargeManagement/changeRemitCardInfotm",
  async (data: any) => {
    const result: any = await changeRemitCardInfotm(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)
export const getremitListAction = createAsyncThunk(
  "rechargeManagement/getremitList",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getremitList(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const surePayedForAction = createAsyncThunk(
  "rechargeManagement/surePayedFor",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await surePayedFor(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const notPayedForAction = createAsyncThunk(
  "rechargeManagement/notPayedFor",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await notPayedFor(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)
